/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
export const isValidURL = (inputURL) => {
  try {
    //try creating URL object with give URL string and see if works
    new URL(inputURL);
    return true;
  } catch (error) {
    //if creating URL object fails , it means we passed invalid URL.
    console.log("invalid url", error);
    return false;
  }
};

export const containsIpAddress = (inputURL) => {
  var myRegexp = /\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/g;
  var match = myRegexp.exec(inputURL);
  if (match !== null) return true;
  else return false;
};

export const isValidEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const isValidPassword = (password) => {
  const re = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])([a-zA-Z0-9@$!%*?&]{8,20})$/;
  return re.test(String(password));
};
